import { Injectable } from '@angular/core';
import { UntypedFormBuilder, UntypedFormArray, UntypedFormGroup } from '@angular/forms';
import { PeremrillojiParametri, PeremriNumri, PeremriRasa, PeremriVeta } from '@core/enums/peremri/peremri.enum';

@Injectable({
  providedIn: 'root'
})
export class PeremriVetvetorFormulaService {

  constructor(private fb: UntypedFormBuilder) { }

  generateFormula(peremriLlojiParametri: PeremrillojiParametri, formArray: UntypedFormArray) {
    if (!peremriLlojiParametri) {
      throw new Error('Lloji i përemrit vetor është i zbrazët');
    }

    const ctrls = this.getFormulaControls(peremriLlojiParametri)

    while (formArray.length > 0) {
      formArray.removeAt(0);
    }

    ctrls.forEach((f) => {
      this.setFormula(formArray, f.rasaId, f.pershkrimi);
    })
  }


  getFormulaControls(
    peremriLlojiParametri: PeremrillojiParametri
  )
    : { rasaId: number, pershkrimi?: string }[] {
    const ctrls: any[] = [];
    switch (peremriLlojiParametri) {
      case PeremrillojiParametri.Rasee: {
        ctrls.push({ rasaId: PeremriRasa.Emerore, pershkrimi: 'vetja', }),
          ctrls.push({ rasaId: PeremriRasa.Gjinore, pershkrimi: 'vetes' }),
          ctrls.push({ rasaId: PeremriRasa.Dhanore, pershkrimi: 'vetes', }),
          ctrls.push({ rasaId: PeremriRasa.Kallezore, pershkrimi: 'veten', }),
          ctrls.push({ rasaId: PeremriRasa.Rrjedhore, pershkrimi: 'vetes' })
        break;
      }
    }
    return ctrls;
  }

  private setFormula(formArray: UntypedFormArray, rasa: PeremriRasa, value?: string) {
    let fg = formArray.controls.find(
      (c) => c.get('rasaId')?.value == rasa
    ) as UntypedFormGroup;
    if (fg) fg.get('pershkrimi')?.setValue(value);
    else {
      let fg = this.fb.group({
        rasaId: rasa,
        pershkrimi: value,
      });
      if (formArray.disabled) fg.disable();
      formArray.push(fg);
    }
  }
}
